// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__R-tC7","lock":"Forbidden_lock__YCSko","dip":"Forbidden_dip__T2Zcw","spin":"Forbidden_spin__QY67a"};